import { parseEther } from "viem";
import { EVMGasProvider } from "../gasProviders";
export const transactionBuilder = async (params) => {
    const { amount, callData, depositAddress, network, selectedWallet, token } = params;
    const tx = {
        chainId: Number(network?.chain_id),
        to: depositAddress,
        value: parseEther(amount.toString()),
        gas: undefined,
        data: callData,
        account: selectedWallet.address
    };
    try {
        const gasData = await new EVMGasProvider().getGas({
            address: selectedWallet.address,
            network,
            token
        });
        if (gasData?.gas)
            tx.gas = BigInt(gasData.gas);
    }
    catch (error) {
        console.log(error);
    }
    return tx;
};
